import { RenderChipProps } from '@/components/core/Games/LastRounds/Chips/props';
import Link from '@/components/core/Link';
import { GameID } from '@/enums/gameId';
import { RootState } from '@/lib/store';
import { CrashGameType } from '@/lib/store/crash/enums/game-type.enum';
import { useSelector } from 'react-redux';
import styles from './styles.module.scss';

export default function CrashLastRoundChip({
  round,
  isLoading,
  cover,
  link,
  modal,
}: RenderChipProps) {
  const gameType = useSelector((state: RootState) => state.crash.gameType);

  if (isLoading) {
    return (
      <div
        className={cover ? styles['skeleton--secondary'] : styles.skeleton}
      />
    );
  }

  return (
    <Link
      className={`${styles.link} ${cover ? styles['link--cover'] : ''}`}
      href={link.replace(
        `game-id=${GameID.Crash?.toString()}`,
        gameType === CrashGameType.Classic
          ? `game-id=${GameID.Crash?.toString()}`
          : `game-id=${GameID.CrashTrenball?.toString()}`,
      )}
      style={{
        color: round?.crash?.tileType?.color,
      }}
      modal={modal}
    >
      <span>{round?.crash?.crashpoint?.toNumberString()}x</span>
      <div
        className={styles.link__dot}
        style={{
          backgroundColor: round?.crash?.tileType?.color,
        }}
      />
    </Link>
  );
}
